import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { CheckCircle, XCircle, PackageCheck } from 'lucide-react';

export const MaterialApprovalsTab = ({ materials, onApprove, t }) => (
  <Card>
    <CardHeader>
      <CardTitle>{t('admin.materialApprovals') || 'Material-Freigabe'}</CardTitle>
      <CardDescription>{t('admin.materialApprovalsDesc') || 'Externe Materialien prüfen und freigeben'}</CardDescription>
    </CardHeader>
    <CardContent>
      {materials.length === 0 ? (
        <div className="text-center py-12">
          <PackageCheck className="h-12 w-12 mx-auto text-muted-foreground/30 mb-3" />
          <p className="text-muted-foreground">{t('admin.noPendingMaterials') || 'Keine ausstehenden Material-Freigaben'}</p>
        </div>
      ) : (
        <div className="space-y-3" data-testid="pending-materials-list">
          {materials.map((m) => (
            <div key={m.material_id} className="border rounded-lg p-4 flex items-center justify-between gap-4" data-testid={`pending-material-${m.material_id}`}>
              <div className="flex-1 min-w-0">
                <p className="font-semibold truncate">{m.common_title}</p>
                <p className="text-sm text-muted-foreground">{m.manufacturer_name} &middot; {m.manufacturer_part_number}</p>
                <div className="flex flex-wrap gap-3 mt-1 text-xs text-muted-foreground">
                  {m.owner_name && <span>{t('admin.submittedBy') || 'Eingereicht von'}: {m.owner_name} ({m.owner_email})</span>}
                  {m.site_name && <span>{m.site_name}, {m.site_city}, {m.site_country}</span>}
                  <span>{m.sku_count} SKU(s)</span>
                  <span>{new Date(m.created_at).toLocaleDateString('de-DE')}</span>
                </div>
              </div>
              <div className="flex gap-2 shrink-0">
                <Button size="sm" className="bg-green-500 hover:bg-green-600 gap-1" onClick={() => onApprove(m.material_id, 'approved')} data-testid={`approve-material-btn-${m.material_id}`}>
                  <CheckCircle className="h-4 w-4" />{t('admin.approve') || 'Freigeben'}
                </Button>
                <Button size="sm" variant="outline" className="gap-1 text-red-600 hover:text-red-700 hover:bg-red-50" onClick={() => onApprove(m.material_id, 'rejected')} data-testid={`reject-material-btn-${m.material_id}`}>
                  <XCircle className="h-4 w-4" />{t('admin.reject') || 'Ablehnen'}
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </CardContent>
  </Card>
);
